const planLabel = (plan) => plan ? `${plan} plan` : 'plan';

export function getActivationFeedback(state) {
  if (!state) {
    return {
      severity: 'warning',
      complete: false,
      message: 'The key was accepted, but its plan status could not be confirmed. Check the plan again or enter a different key.'
    };
  }

  if (state.mode === 'full') {
    return {
      severity: 'success',
      complete: true,
      message: `Activation key accepted. Your ${planLabel(state.plan)} is now active.`
    };
  }

  if (state.mode === 'past_due') {
    return {
      severity: 'warning',
      complete: false,
      message: `The key is linked to your ${planLabel(state.plan)}, but the subscription has a payment problem. Enter a different active key or resolve the payment.`
    };
  }

  if (state.mode === 'readonly') {
    return {
      severity: 'warning',
      complete: false,
      message: `The key is linked to your ${planLabel(state.plan)}, but that license is inactive or expired. Enter a different active key or choose a new plan.`
    };
  }

  return {
    severity: 'warning',
    complete: false,
    message: 'The key was linked, but it did not activate paid access. Enter a different active key or choose a plan.'
  };
}
